import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import HttpBackend from 'i18next-http-backend';
import enTranslation from '../locales/en.json';
import ruTranslation from '../locales/ru.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'ru', label: 'Русский' },
] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number]['code'];

export async function initI18n(lang: Language): Promise<void> {
  if (i18n.isInitialized) return;
  const initPromise = i18n
    .use(ChainedBackend)
    .use(initReactI18next)
    .init({
      lng: lang,
      fallbackLng: 'en',
      ns: ['translation'],
      defaultNS: 'translation',
      resources: {
        en: { translation: enTranslation },
        ru: { translation: ruTranslation },
      },
      backend: {
        backends: [LocalStorageBackend, HttpBackend],
        backendOptions: [
          { expirationTime: 7 * 24 * 60 * 60 * 1000 },
          { loadPath: '/locales/{{lng}}/translation.json' },
        ],
      },
      partialBundledLanguages: true,
      interpolation: { escapeValue: false },
      react: { useSuspense: false },
    });

  await Promise.race([
    initPromise,
    new Promise<void>((resolve) => setTimeout(resolve, 2000)),
  ]);
}

export { i18n };
